<div class="dashboard-header">
            <nav class="dashboard-header-nav">
                <ul class="dashboard-actions">
                    <app-clientes-backoffice-button></app-clientes-backoffice-button>                   
                    <li>
                        <button nz-button nzType="text" nzDanger class="dashboard-logout" (click)="authService.logout()" aria-label="Cerrar sesión"><i class="far fa-sign-out"></i></button>
                    </li>                    
                </ul>
            </nav>
</div>
<div class="dashboard-logo">
    <img src="assets/site_logo_gradiente.svg" alt="GioSite" />
</div>
